import { Pipe, PipeTransform } from '@angular/core';
import { OrderBatch } from '@services/order-batch/order-batch.model';

@Pipe({
  name: 'filterBatches',
  standalone: false,
})
export class filterBatchesPipe implements PipeTransform {
  transform(batches: any, text: string): any[] {
    if (text && text.length) {
      return batches.filter((batch) => batch.name.toLowerCase().includes(text.toLowerCase()));
    }

    return batches;
  }
}

@Pipe({
  name: 'onlyWithOrders',
  standalone: false,
})
export class onlyWithOrdersPipe implements PipeTransform {
  transform(batches: OrderBatch[]): any[] {
    return batches.filter((batch) => batch.orders.length > 0);
  }
}
